import { Accordion } from 'components/universal/accordion';
import { Button } from 'components/universal/button';
import { Checkbox } from 'components/universal/checkbox';
import { FormModal } from 'components/universal/form-modal';
import Heading from 'components/universal/heading';
import { Input } from 'components/universal/input';
import InputPasswodHideAndShow from 'components/universal/input-passwod-hide-and-show';
import Paragraph from 'components/universal/paragraph';
import { PASSWORD_ADNOTATION } from 'constants/validation-error-messages';
import { Controller } from 'react-hook-form';
import { components } from 'react-select';
import { AsyncPaginate } from 'react-select-async-paginate';
import { fetchDepartmentsPaginated, getWorkplaces } from 'services/registration';
import { ReactComponent as ArrowDown } from '../../assets/images/icon/icon-down.svg';
import { RegistrationClause } from './RegistrationClause';
import cls from './registration.module.scss';
import { useRegistrationHook } from './useRegistrationHook';
import cities from '../../utils/cities.json';
import Select from 'react-select';

const DropdownIndicator = (props) => {
    return (
        <>
            <components.DropdownIndicator {...props}>
                <ArrowDown />
            </components.DropdownIndicator>
        </>
    );
};

export const RegistrationView = () => {
    const {
        register,
        control,
        handleSubmit,
        onSubmit,
        errors,
        t,
        showPassword,
        showPasswordSecond,
        togglePassword,
        togglePasswordRepeat,
        onKeyUpHandle,
        setValueForm,
        openModal,
        goBack,
        setValue,
        setWorkplaceId,
        debouncedSearch,
        onChangeCity,
        debouncedSearchCity,
        debouncedSearchName,
        setSearchName,
        searchName,
        formatZipCode,
        selectedWorkplace,
        loadWorkplaceOptions,
        handleWorkplaceChange,
        selectedDepartment,
        loadDepartmentOptions,
        handleDepartmentChange,
        workplaceId,
    } = useRegistrationHook();
    
    return (
        <div className={cls.container}>
            <div className={cls.columnLeft}>
                <Heading
                    className={cls.heading}
                    headingLevel="h1"
                    headingStyle="h2"
                >
                    {t('registration.title')}
                </Heading>
                <Paragraph 
                    className={`${cls.paragraph} mb-10`}
                >
                    {t('registration.desc')}
                </Paragraph>
                <form className={cls.form} onSubmit={handleSubmit(onSubmit)}>
                    <Heading 
                        headingLevel="h3" 
                        className={`${cls.heading2} mb-5`}
                    >
                        {t('registration.yourData')}
                    </Heading>
                    <div className={cls.formFields}>
                        <Input
                            className={`${cls.input} mb-6`}
                            register={register}
                            id="first_name"
                            name="first_name"
                            label={t('registration.firstNameRequire')}
                            error={t(errors.first_name?.message)}
                            maxLength={255}
                        />
                        <Input
                            className={`${cls.input} mb-6`}
                            register={register}
                            id="last_name"
                            name="last_name"
                            label={t('registration.lastNameRequire')}
                            error={t(errors.last_name?.message)}
                            maxLength={255}
                        />
                        <Input
                            className={`${cls.input} ${cls.fullInput}`}
                            register={register}
                            id="email"
                            name="email"
                            label={t('registration.emailRequire')}
                            error={t(errors.email?.message)}
                            maxLength={255}
                        />
                        <InputPasswodHideAndShow
                            onClick={togglePassword}
                        >
                            <Input
                                className={`${cls.inputCustom} mb-6`}
                                register={register}
                                id="password"
                                name="password"
                                label={t('registration.passwordRequire')}
                                error={t(errors.password?.message)}
                                maxLength={255}
                                type={!showPassword ? 'password' : 'text'}
                                adnotation={t(PASSWORD_ADNOTATION)}
                            />
                        </InputPasswodHideAndShow>
                        <InputPasswodHideAndShow
                            onClick={togglePasswordRepeat}
                        >
                            <Input
                                className={`${cls.inputCustom} mb-6`}
                                register={register}
                                id="password_repeat"
                                name="password_repeat"
                                label={t('registration.repeatPasswordRequire')}
                                error={t(errors.password_repeat?.message)}
                                maxLength={255}
                                type={!showPasswordSecond ? 'password' : 'text'}
                            />
                        </InputPasswodHideAndShow>
                    </div>
                    <Heading 
                        headingLevel="h3" 
                        className={`${cls.heading2} mb-5`}
                    >
                        {t('registration.workplaceData')}
                    </Heading>

                    <div className={`${cls.formFields} ${cls.formFieldsSecond}`}>
                        <Input
                            className={`${cls.input} mb-6`}
                            register={register}
                            id="workplace_address_postcode"
                            name="workplace_address_postcode"
                            label={t('registration.zipCodeRequire')}
                            error={t(
                                errors.workplace_address_postcode?.message
                            )}
                            onKeyUp={onKeyUpHandle}
                            maxLength={6}
                            onChange={formatZipCode}
                        />
                        <div className={cls.select}>
                            <label htmlFor="workplace_address_city" className={cls.label}>
                                {t('registration.cityRequire')}
                            </label>
                            <Controller
                                name="workplace_address_city"
                                control={control}
                                render={({ field }) => (
                                <Select
                                    {...field}
                                    options={cities}
                                    className={errors.workplace_address_city ? 'error react-select-container' : 'react-select-container'}
                                    classNamePrefix="react-select"
                                    placeholder=""
                                    components={{ DropdownIndicator }}
                                    onChange={(selected) => {
                                        onChangeCity(selected);
                                        setValue('workplace_name', null);
                                        return field.onChange(selected?.value)
                                    }}
                                    
                                    value={cities.find((c) => c.value === field.value) || null}
                                    noOptionsMessage={() => t('registration.noOptionsRequire')}
                                />
                                )}
                            />
                            {errors.workplace_address_city?.message && (
                                <p className={cls.errorBox}>{t(errors.workplace_address_city?.message)}</p>
                            )}
                        </div>
                        <div className={cls.select}>
                            <label className={cls.label}>
                                {t('registration.firstLoginModal.workplace')}
                            </label>
                            <AsyncPaginate
                                className="react-select-container"
                                classNamePrefix="react-select"
                                components={{ DropdownIndicator }}
                                placeholder=""
                                value={selectedWorkplace}
                                loadOptions={loadWorkplaceOptions}
                                additional={{ page: 1 }}
                                onChange={handleWorkplaceChange as any}
                                noOptionsMessage={() => t('registration.noOptions')}
                                debounceTimeout={300}
                            />
                        </div>
                        <div className={`${cls.select} ${workplaceId === 0 ? cls.disabled : ''}`}>
                            <label className={cls.label}>
                                {t('registration.firstLoginModal.department')}
                            </label>
                            <Controller
                                name="department_id"
                                control={control}
                                render={({ field }) => (
                                    <AsyncPaginate
                                        key={workplaceId}
                                        className={errors.department_id ? 'error react-select-container' : 'react-select-container'}
                                        classNamePrefix="react-select"
                                        components={{ DropdownIndicator }}
                                        placeholder=""
                                        isDisabled={workplaceId === 0}
                                        value={selectedDepartment}
                                        loadOptions={loadDepartmentOptions}
                                        additional={{ page: 1 }}
                                        onChange={(selected) => handleDepartmentChange(selected as any, field.onChange)}
                                        noOptionsMessage={() => t('registration.noDepartments')}
                                        debounceTimeout={300}
                                    />
                                )}
                            />
                            {errors.department_id && (
                                <p className={cls.errorBox}>{t(errors.department_id.message).replace('department id', t('registration.firstLoginModal.department').toLowerCase())}</p>
                            )}                       
                        </div>
                        <Input
                            className={`${cls.input} mb-6`}
                            register={register}
                            id="workplace_address_street"
                            name="workplace_address_street"
                            label={t('registration.streetRequire')}
                            error={t(errors.workplace_address_street?.message)}
                            maxLength={255}
                        />
                        <Input
                            className={`${cls.input} mb-6`}
                            register={register}
                            id="workplace_address_number"
                            name="workplace_address_number"
                            label={t('registration.apartmentNumberRequire')}
                            error={t(errors.workplace_address_number?.message)}
                            maxLength={255}
                        />
                        <Input
                            className={`${cls.input} mb-6 ${cls.fullInput}`}
                            register={register}
                            id="employee_position_name"
                            name="employee_position_name"
                            label={t('registration.positionRequire')}
                            error={t(errors.employee_position_name?.message)}
                            maxLength={255}
                        />
                    </div>
                    <Checkbox
                        className={cls.checkbox}
                        register={register}
                        id="agreement"
                        name="agreement"
                        label={t('registration.consent')}
                        error={t(errors.agreement?.message)}
                    />
                    <Accordion
                        label={t('registration.infoClause')}
                        arrow
                        height={300}
                        className={cls.accordion}
                    >
                        <RegistrationClause />
                    </Accordion>

                    <div className={cls.buttonWrapper}>
                        <Button 
                            className={`${cls.button} mx-auto mb-5`} 
                            styleType="border"
                            onClick={goBack}
                            type="button"
                        >
                            {t('resetPassword.goBackButton')}
                        </Button>
                        <Button className={cls.button} type="submit">
                            {t('registration.register')}
                        </Button>
                    </div>
                </form>
                <FormModal 
                    setValueForm={setValueForm}
                />
            </div>
        </div>
    );
};
